<template>
	<div>
		<div class="popBoxBg" v-show="show"></div>
		<div class="detailsBox" v-show="show">
			<div class="read-bd-title fc"><i></i>
				<h3>单据号码：45613</h3>
			</div>
			<div class="bd">
				<el-table :data="tableData" style="width: 100%" height="500">
					<el-table-column prop="col1" label="项目名称" width="350">
					</el-table-column>
					<el-table-column prop="col2" label="数量" width="120">
					</el-table-column>
					<el-table-column prop="col3" label="单位" width="100">
					</el-table-column>
					<el-table-column prop="col4" label="单价" width="100">
					</el-table-column>
					<el-table-column prop="col5" label="执行科室">
					</el-table-column>
					
					
				</el-table>
			</div>
			<div class="ft fc-bet">
				<div class="left">
					<p>
						开单医生：张三   开单时间：2021-11-06  00:15 拷贝
					</p>
					<div class="total">
						<span>合计金额：</span>
						<b class="red">35.51元</b>
					</div>
				</div>
				<div class="right">
					<button type="button" class="btn-return fcc" @click="close">
						<img src="../../assets/icon/icon-return.png" >
						<span>返回</span>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'q-details',
		// props: {
		// 	msg: String
		// },
		data() {
			return {
				//timer:null,
				show: false,

				tableData: [{
						col1: '阿莫西林',
						col2: 'data',
						col3: 'data',
						col4: 'data',
						col5: 'data',
						
					},
					{
						col1: '阿莫西林',
						col2: 'data',
						col3: 'data',
						col4: 'data',
						col5: 'data',
						
					}
				]
			}
		},


		mounted() {

		},
		methods: {
			close(){
				this.show=false
			}
		},
		beforeDestroy() {
			//clearTimeout(this.timer);
		}

	}
</script>

<style lang="less">
	.detailsBox {
		width: 874px;
		height: 733px;
		border-radius: 20px;
		position: absolute;
		background-color: #fff;
		left: 50%;
		z-index: 10;
		margin-left: -437px;
		bottom: 120px;

		.read-bd-title {
			padding-left: 30px;

			h3 {
				font-weight: 400;
			}
		}
	}

	.el-table .has-gutter .el-table__cell {
		padding: 0;
		height: 74px;
		background-color: #1EB3B1;
		font-size: 30px;
		color: #fff;

	}

	.el-table th.el-table__cell>.cell {
		font-size: 30px;
		color: #fff;
		height: 74px;
		line-height: 74px;
		font-weight: normal;
	}

	.el-table .el-table__row .el-table__cell {
		border-bottom: 1px solid #F6EFEF;
		height: 60px;
		line-height: 60px;

		font-size: 25px;
		color: #000;
	}
	.ft{
		padding: 27px;
		font-size: 20px;
		color: #696969;
		line-height: 2em;
		.total{
			font-size: 25px;
			color: #000000;
		}
		b{
			color: #FF0000;
			font-weight: 700;
		}
	}
	.btn-return{
		width: 197px;
		height: 92px;
		background-color: #38BB8B;
		outline: none;
		img{
			margin-right: 13px;
		}
		font-size: 30px;
		color: #fff;
	}
</style>
